import { FC } from "react";
import { IconProps } from "./types";

export const SocialLinkedinCircle: FC<IconProps> = ({
  fill = "#000",
  width = 24,
  height = 24,
  className,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width={width}
    height={height}
    className={className}
    {...props}
  >
    <path
      d="M6.269 7.8c0-.725.55-1.278 1.389-1.278.84 0 1.358.553 1.374 1.279 0 .708-.533 1.277-1.39 1.277h-.017c-.823 0-1.356-.569-1.356-1.277z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.687 11.133c.328-.504.911-1.22 2.215-1.22 1.617 0 2.83 1.056 2.83 3.327v4.238h-2.457v-3.955c0-.993-.356-1.672-1.246-1.672-.678 0-1.083.46-1.261.9-.065.158-.08.377-.08.599v4.128H10.23s.032-6.699 0-7.392h2.457v1.047zm0 0a.181.181 0 0 1-.016.025h.016v-.025z"
      fill={fill}
    />
    <path d="M6.413 17.478h2.458v-7.391H6.413v7.391z" fill="#000" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12zm-1.5 0c0 5.799-4.701 10.5-10.5 10.5S1.5 17.799 1.5 12 6.201 1.5 12 1.5 22.5 6.201 22.5 12z"
      fill={fill}
    />
  </svg>
);
